<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { request } from '@/util/request';

const data = ref();

function dataGet(data: any, status: string) {
  return data?.count?.find((i: any) => i.status === status)?.count || 0;
}

function dataCount(data: any) {
  return (
    data?.count
      ?.map((i: any) => i.count)
      ?.reduce((a: any, b: any) => a + b, 0) || 0
  );
}

onMounted(async () => {
  data.value = await request('/management/index/index');
  console.log(data.value);
});
</script>

<template>
  <div>
    <div class="title">LAOT 终端网络管理平台</div>
    <template v-if="data">
      <a-row :gutter="[16, 16]">
        <a-col :span="24">
          <a-card size="small">
            {{ data.content?.notification }}
          </a-card>
        </a-col>
        <a-col :span="24">
          <a-card size="small">
            <div v-html="data.content?.kefu" />
          </a-card>
        </a-col>
      </a-row>
      <div class="sub-title">设备情况</div>
      <a-row :gutter="16">
        <a-col :span="6">
          <a-card>
            <a-statistic
              title="设备数"
              :value="dataCount(data.device)"
              style="margin-right: 50px"
            >
            </a-statistic>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card>
            <a-statistic
              title="在线"
              :value="dataGet(data.device, 'online')"
              :value-style="{ color: '#3f8600' }"
            >
            </a-statistic>
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card>
            <a-statistic
              title="异常"
              :value="dataGet(data.device, 'error')"
              :value-style="{ color: '#cf1322' }"
            />
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card>
            <a-statistic
              title="离线"
              :value="dataGet(data.device, 'offline')"
            />
          </a-card>
        </a-col>
      </a-row>
      <div class="sub-title">线路情况</div>
      <a-row :gutter="16">
        <a-col :span="6">
          <a-card>
            <a-statistic title="线路数" :value="dataCount(data.proxy)" />
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card>
            <a-statistic
              title="正常线路"
              :value="dataGet(data.proxy, 'normal')"
              :value-style="{ color: '#3f8600' }"
            />
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card>
            <a-statistic
              title="异常线路"
              :value="dataGet(data.proxy, 'error')"
              :value-style="{ color: '#cf1322' }"
            />
          </a-card>
        </a-col>
        <a-col :span="6">
          <a-card>
            <a-statistic
              title="未检测线路"
              :value="dataGet(data.proxy, 'unknown')"
            />
          </a-card>
        </a-col>
      </a-row>
    </template>
  </div>
</template>

<style scoped lang="scss">
.title {
  color: $color-content-text-primary;
  font-size: $font-size-large;
  font-weight: $font-weight-primary;
  margin: $spacing-extra-large 0;
}

.sub-title {
  margin: $spacing-medium 0;
}
</style>
